import React from 'react'

import { navigationPaths } from 'app/config'

/**
 * Column options that draw a row's parent name or phone as a link to the
 * parent's Alfred profile (Parent Dashboard), opening in a new tab.
 *
 * `rowsRef.current` must hold the rows exactly as passed to the table:
 * customBodyRenderLite gets the index into that array, which stays correct
 * under the header filters because AtHomeCrudPage passes every row and lets
 * mui-datatables do the filtering.
 */
export const parentLinkOptions = (rowsRef, field) => ({
  customBodyRenderLite: (i) => {
    const row = rowsRef.current[i]
    if (!row || !row[field]) return '—'
    return row.parentUuid ? (
      <a
        href={`${navigationPaths.parentdashboard}?parent=${row.parentUuid}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ whiteSpace: 'nowrap' }}
      >
        {row[field]}
      </a>
    ) : (
      row[field]
    )
  }
})
